// packages/web/src/components/GlobalCreate.tsx — R3: the app-wide "+" that
// opens the GLOBAL create menu (components/RecordEditor.tsx → every creatable
// type). Pinned top-right of the shell so a manual create is always one tap
// away, on every screen and every breakpoint — the manual-first baseline's
// front door. Deliberately quiet (ghost, hairline) so it never competes with
// the Knot (the auto-capture accelerator) or a screen's own content.
import { openCreateMenu } from '../lib/recordEditor';
import './GlobalCreate.css';

export function GlobalCreate() {
  return (
    <button
      type="button"
      class="global-create"
      onClick={openCreateMenu}
      aria-label="Create a record"
      data-testid="global-create"
    >
      <span aria-hidden="true">+</span>
    </button>
  );
}
